import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Input, Select, message, InputNumber } from 'antd';
import { graphql, compose } from 'react-apollo';
import { edlCourseTypeOptions } from '../utils/globals';

import AllEdlCollegesQuery from '../graphql/queries/allEdlCollegesQuery.graphql';
import CreateEdlCourseMutation from '../graphql/mutations/createEdlCourseMutation.graphql';

const FormItem = Form.Item;
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 12 },
    md: { span: 8 },
    lg: { span: 8 },
    xl: { span: 8 },
    xxl: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 12 },
    md: { span: 15 },
    lg: { span: 15 },
    xl: { span: 15 },
    xxl: { span: 15 },
  },
};

class NewEdlCourseModalForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = () => {
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, closeModal, edlCollegeId } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({
          variables: { ...values, edlCollegeId },
          update: (cache, { data: { newCourse } }) => {
            const data = cache.readQuery({ query: AllEdlCollegesQuery });
            for (let i = 0; i < data.colleges.length; i++) {
              const college = data.colleges[i];
              if (college.id === edlCollegeId) {
                if (!Array.isArray(college.courses)) college.courses = [];
                college.courses.push(newCourse);
                break;
              }
            }
            cache.writeQuery({ query: AllEdlCollegesQuery, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            closeModal();
            form.resetFields();
            message.success('New course added!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form, visible, closeModal } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Modal title="Add new course" visible={visible} onOk={this.handleSubmit} onCancel={closeModal}>
        <Form layout="horizontal">
          <FormItem label="Course Name" hasFeedback {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Course Type" hasFeedback {...formItemLayout}>
            {getFieldDecorator('type', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(
              <Select disabled={submittingForm} showSearch>
                {edlCourseTypeOptions.map((entry) => (
                  <Option key={entry.value} value={entry.value}>
                    {entry.name}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="Duration (years)" hasFeedback {...formItemLayout}>
            {getFieldDecorator('durationYears', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<InputNumber disabled={submittingForm} />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

NewEdlCourseModalForm.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  edlCollegeId: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default compose(
  graphql(CreateEdlCourseMutation),
  Form.create(),
)(NewEdlCourseModalForm);



// WEBPACK FOOTER //
// ./src/modalForms/NewEdlCourseModalForm.jsx